import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { DoctorTreatments } from '../partner/doctor-treatment/doctor-treatment.component';



@Injectable({
  providedIn: 'root'
})
export class DoctorService {
  private apiUrl = environment.apiUrl
  doctorData: any = JSON.parse(localStorage.getItem('logindata'))
  headers: HttpHeaders
  doctorBlogKeys = ['doctorId', '_id', 'text', 'image', 'title', 'type']

  constructor(private http: HttpClient) {

    let accesstoken = this.doctorData != null ? this.doctorData['accessToken'] : ''
    this.headers = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
  }

  addPrescription(bookingID, prescriptionText, description) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    let data = {}
    data["bookingId"] = bookingID
    if (prescriptionText != '')
      data["prescription"] = prescriptionText
    data["description"] = description

    return this.http.post(`${this.apiUrl}/Doctor/addPrescription`, data, { headers: headers1 })
  }
  addTreatment(doctorTreatmentData, doctorData) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.post(`${this.apiUrl}/Doctor/addTreatments`, doctorTreatmentData, { headers: headers1 })
  }
  setPasword(password) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.put(`${this.apiUrl}/Doctor/setPassword`, { password: password }, { headers: headers1 })
  }
  listTreatment(doctorsData) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.post(`${this.apiUrl}/Doctor/listTreatments`, {}, { headers: headers1 })
  }
  updateDoctorTreatment(testObj, doctorData: DoctorTreatments) {

    // delete testObj['_id']
    delete testObj['createdAt']
    delete testObj['doctorId']
    //delete testObj['labId']
    delete testObj['__v']
    delete testObj['hospitalId']
    delete testObj['isDeleted']
    // testObj['_id'] = doctorData['_id']
    console.log(testObj)

    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.post(`${this.apiUrl}/Doctor/addTreatments`, testObj, { headers: headers1 })
  }
  getBlogs(doctorData) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.post(`${this.apiUrl}/Doctor/listBlog`, {}, { headers: headers1 })
  }
  getBlog(id) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.post(`${this.apiUrl}/Doctor/listBlog`, { _id: id }, { headers: headers1 })
  }

  addEditBlog(blog, id) {

    if (id)
      blog['_id'] = blog['_id']
    blog['doctorId'] = this.doctorData['_id']


    let userUpdateKeys = this.doctorBlogKeys
    Object.keys(blog).forEach(function (key) {

      let exist = userUpdateKeys.find(ob => ob == key);
      if (exist == null || blog[key] == '' || !blog[key])
        delete blog[key]

    });


    // delete blog['createdAt']
    // delete blog['__v']
    // delete blog['hospitalId']
    // delete blog['adminVerified']
    // delete blog['isDeleted']
    // delete blog['uniquekey']
    //blog['doctorId'] = this.doctorData['_id']
    console.log(blog)

    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.post(`${this.apiUrl}/Doctor/addEditBlog`, blog, { headers: headers1 })

  }
  listTiming(type) {

    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.get(`${this.apiUrl}/${type}/listTiming`, { headers: headers1 })

  }
  addTiming(timing, type) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.post(`${this.apiUrl}/${type}/addEditTiming`, { timing: timing }, { headers: headers1 })
  }




  // User Side///

  getDoctorsList(object = { value: { name: '', city: '', treatment: '' } }) {
    console.log(object.value)
    let lat = localStorage.getItem('lat')
    let lng = localStorage.getItem('lng')
    let params = {}
    if (lat == 'undefined') {

    }
    else {
      params["lat"] = lat
    }

    if (lng == 'undefined') {

    }
    else {
      params["lng"] = lng
    }


    if (object && object.value) {
      if (object.value.name) {
        params["name"] = object.value.name
      }
      if (object.value.treatment) {
        params["treatment"] = object.value.treatment
      }
      if (object.value.city) {
        params["city"] = object.value.city.toLowerCase()
      }
    }



    const httpOptions = {

      params: params
    };

    return this.http.get(`${this.apiUrl}/User/listDoctors`, httpOptions)
  }
  getDoctorDetail(doctorId: string, latest_date) {


    let params = {}
    params['_id'] = doctorId
    params['bookingDate'] = latest_date

    const httpOptions = {

      params: params
    };

    return this.http.get(`${this.apiUrl}/User/listDoctorDetailData`, httpOptions)
  }
  getDoctorBookings(date = null, phoneNo = '') {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    if (date && phoneNo)
      return this.http.get(`${this.apiUrl}/Doctor/listBookings?date=${date}&phoneNo=${phoneNo}`, { headers: headers1 })

    else if (phoneNo)
      return this.http.get(`${this.apiUrl}/Doctor/listBookings?phoneNo=${phoneNo}`, { headers: headers1 })
    else if (date)
      return this.http.get(`${this.apiUrl}/Doctor/listBookings?date=${date}`, { headers: headers1 })
    else
      return this.http.get(`${this.apiUrl}/Doctor/listBookings`, { headers: headers1 })

  }
  listUsers() {

    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.get(`${this.apiUrl}/Doctor/listUsers`, { headers: headers1 })

  }
  listMessages(userID) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.get(`${this.apiUrl}/Doctor/listMessages?userId=${userID}&skip=0`, { headers: headers1 })

  }
  sendMessage(userID, message, messageType = 'TEXT') {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    let params = {}
    params['userId'] = userID
    params['message'] = message
    params['messageType'] = messageType


    const httpOptions = {

      params: params
    };
    return this.http.post(`${this.apiUrl}/Doctor/sendMessage`, params, { headers: headers1 })
  }
  updateBookingStatus(status: string, bookingID: string) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.put(`${this.apiUrl}/Doctor/bookingStatusUpdate`, { _id: bookingID, status: status }, { headers: headers1 })
  }
  deleteBlog(blogId) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    return this.http.put(`${this.apiUrl}/Doctor/deleteBlog`, { blogId: blogId, isDeleted: true }, { headers: headers1 })
  }
  getReviews() {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });


    return this.http.get(`${this.apiUrl}/Doctor/listReview`, { headers: headers1 })

  }
  getPatientGraphData() {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });


    return this.http.get(`${this.apiUrl}/Doctor/patientGraph`, { headers: headers1 })
  }
  getRevenueGraphData() {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });


    return this.http.get(`${this.apiUrl}/Doctor/revenueGraph`, { headers: headers1 })
  }
  getUserDetail(userId) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });
    console.log(headers1)
    let params = {}
    params['userId'] = userId


    const httpOptions = {

      params: params
    };

    return this.http.get(`${this.apiUrl}/Doctor/listUsersDetails?userId=${userId}`, { headers: headers1 })

  }
  deleteTreatment(treatmentId) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.put(`${this.apiUrl}/Doctor/deleteTreatments`, { _id: treatmentId, isDeleted: true }, { headers: headers1 })
  }
  readMessages(userId) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.put(`${this.apiUrl}/Doctor/readMessages`, { userId: userId }, { headers: headers1 })
  }
  applyFilter(availability, consultation, gender, lang, timing, rating, lat, lng, object) {
    let params = {}
    if (availability != '') {
      params['availability'] = availability
    }
    if (consultation != '') {
      params['consultation'] = consultation
    }
    if (gender != '') {
      params['gender'] = gender
    }
    if (lang != '') {
      params['languages'] = lang
    }
    if (timing != '') {
      params['timing'] = timing
    }
    console.log(isNaN(lat))
    if (rating != '') {
      params["sortBy"] = rating
    }
    else if (lat != 0 && !isNaN(lat)) {
      params["lat"] = lat
      params["lng"] = lng
    }
    console.log(params)
    if (object.name) {
      params["name"] = object.name
    }
    if (object.treatment) {
      params["treatment"] = object.treatment
    }
    if (object.city) {
      params["city"] = object.city
    }


    const httpOptions = {

      params: params
    };
    return this.http.get(`${this.apiUrl}/User/filter`, httpOptions)
  }

  doctorBooking(sendBookingData) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',

    });

    return this.http.post(`${this.apiUrl}/Doctor/createOrder`, sendBookingData, { headers: headers1 })
  }
  doctorLogout() {
    let token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'content-Type': 'application/json',
      //'content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer ' + token,
      'accept': 'application/json',

    });

    return this.http.put(`${this.apiUrl}/Doctor/logout`, {}, { headers: headers })
  }

  getVideoCall(obj) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',
    });
    return this.http.post(`${this.apiUrl}/Doctor/startVideoCall`, obj, { headers: headers1 })
  }

  endVideoCall(obj) {
    let accesstoken = localStorage.getItem('token')
    let headers1 = new HttpHeaders({
      'content-Type': 'application/json',
      'authorization': 'Bearer ' + accesstoken,
      'accept': 'application/json',
    });
    return this.http.post(`${this.apiUrl}/Doctor/endCall`, obj, { headers: headers1 })
  }

}
